/**
 * @module Experience/Shared-Browse
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */ /** */

export const ACCESSORIES_CAROUSEL_CONSTANTS = {
  ZERO: 0,
  DEVICE: 'DEVICE',
  MOBILE_INTERNET: 'mobile-internet',
  NEXTBUTTON: 'Click to scroll through Carousel',
};
